<template>
    <div class="page-wrapper">
        <div class="page-header">
            <widgetToolbar :title="users_data ? `Users (${users_data.total || 0})` : `Users`"
                :icon="require('@/assets/admin-icon/menu/users_active.svg')">
                <div class="options">
                    <widgetSearch class="search-user" placeholder="Search users..." icon="right"
                        v-model="filter_form.query" @keyup="searchUser">
                    </widgetSearch>

                    <div class="v-line-divider" style="height: 40px"></div>

                    <widgetDropdown v-model="filter_dropdown" :right="true" :hover="false" :interactive="true">
                        <button class="btn-dropdown">
                            <span v-if="filter_data == 'all'">All Users</span>
                            <span v-else-if="filter_data == 'students'">Students</span>
                            <span v-else-if="filter_data == 'instructors'">Instructors</span>
                            <!-- <span v-else-if="filter_data == 'consultants'">Consultants</span>
                            <span v-else-if="filter_data == 'customers'">Customers</span>
                            <span v-else-if="filter_data == 'admins'">Admins</span>-->
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in user_type_filter" :key="index"
                                @click="filterByUserType(item)">
                                {{ item.name }}</a>
                        </div>
                    </widgetDropdown>

                    <div class="v-line-divider" style="height: 40px"></div>

                    <widgetDropdown v-model="school_filter_dropdown" :right="true" :hover="false" :interactive="true">
                        <button class="btn-dropdown">
                            <span v-if="school_filter_data == 'all'">All Schools</span>
                            <span v-else>{{ getSelectedSchoolName() }}</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right schools-dropdown">
                            <div class="dropdown-search">
                                <input type="text" placeholder="Search schools..." v-model="school_search_query"
                                    @input="searchSchools" class="search-input" />
                            </div>
                            <div class="dropdown-items">
                                <a class="dropdown-item" href="#"
                                    @click="filterBySchool({ name: 'All Schools', value: 'all' })">
                                    All Schools</a>
                                <div v-if="loadingSchools" class="loading-item">
                                    <span>Loading schools...</span>
                                </div>
                                <a class="dropdown-item" href="#" v-for="(school, index) in filtered_schools"
                                    :key="index"
                                    @click="filterBySchool({ name: getSchoolDisplayName(school), value: school.id })">
                                    {{ getSchoolDisplayName(school) }}</a>
                                <div v-if="!loadingSchools && filtered_schools.length === 0 && school_search_query"
                                    class="no-results">
                                    No schools found
                                </div>
                            </div>
                        </div>
                    </widgetDropdown>

                </div>
            </widgetToolbar>
        </div>

        <div class="page-body">
            <div class="users-list-container">
                <div class="users-table-wrapper">
                    <table class="users-table">
                        <thead>
                            <tr>
                                <th class="table-header">
                                    <input type="checkbox" v-model="selectAll" @change="toggleSelectAll"
                                        class="checkbox">
                                </th>
                                <th class="table-header">User</th>
                                <th class="table-header">Type</th>
                                <th class="table-header">Email</th>
                                <th class="table-header">Status</th>
                                <th class="table-header">Created Date</th>
                                <th class="table-header">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(user, index) in filtered_users" :key="user.id" class="table-row"
                                :class="{ selected: selectedUsers.includes(user.id) }">
                                <td class="table-cell">
                                    <input type="checkbox" v-model="selectedUsers" :value="user.id" class="checkbox">
                                </td>
                                <td class="table-cell">
                                    <div class="user-info">
                                        <widgetProfile :title="user.first_name + ' ' + user.last_name"
                                            :subtitle="user.profile ? user.profile.address : ''"
                                            :file_name="user.profile_picture" :path="$fullUrl('images/profiles/')">
                                        </widgetProfile>
                                    </div>
                                </td>
                                <td class="table-cell">
                                    <span class="user-type" :class="getUserType(user.account_type)">
                                        {{ getUserTypeLabel(user.account_type) }}
                                    </span>
                                </td>
                                <td class="table-cell">{{ user.email }}</td>
                                <td class="table-cell">
                                    <span class="status-badge" :class="getUserStatus(user)">
                                        {{ getUserStatusLabel(user) }}
                                    </span>
                                </td>
                                <td class="table-cell">{{ formatDate(user.created_at) }}</td>
                                <td class="table-cell">
                                    <dropdownMenu>
                                        <ul>
                                            <li><a href="#" @click="changePassword(user)">Change Password</a></li>
                                            <li><a href="#" @click="toggleUserStatus(user)">
                                                    {{ user.activated ? 'Deactivate' : 'Activate' }}
                                                </a></li>
                                            <li v-if="!user.banned"><a href="#" @click="banUser(user)">Ban User</a></li>
                                            <li v-if="user.banned"><a href="#" @click="unbanUser(user)">Unban User</a>
                                            </li>
                                            <li>
                                                <a href="#" class="text-danger" @click="confirmDeleteUser(user)">Delete
                                                    User</a>
                                            </li>
                                        </ul>
                                    </dropdownMenu>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="!filtered_users || filtered_users.length === 0" class="empty-state">
                        <img src="@/assets/icons/user-ic.svg" class="empty-icon" />
                        <h3>No Users Found</h3>
                        <p>{{ filter_data === 'all' ? 'No users available.' : `No ${filter_data} found.` }}</p>
                    </div>
                </div>

                <!-- Pagination -->
                <div class="pagination-wrapper" v-if="users_data && users_data.total > users_data.per_page">
                    <div class="pagination-info">
                        Showing {{ users_data.from }} to {{ users_data.to }} of {{ users_data.total }} users
                    </div>
                    <div class="pagination-controls">
                        <button @click="changePage(users_data.current_page - 1)"
                            :disabled="users_data.current_page === 1" class="pagination-btn">
                            Previous
                        </button>
                        <span class="pagination-page">{{ users_data.current_page }} of {{ users_data.last_page }}</span>
                        <button @click="changePage(users_data.current_page + 1)"
                            :disabled="users_data.current_page === users_data.last_page" class="pagination-btn">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Change Password Modal -->
        <ChangePasswordModal v-if="showPasswordModal" :user="selectedUser" @onPasswordChanged="handlePasswordChanged"
            @onCancel="closePasswordModal" @onError="handlePasswordError" />
    </div>
</template>

<script>
import ChangePasswordModal from './modals/ChangePasswordModal.vue';
import { mapActions, mapGetters } from 'vuex';
import { eventBus } from '@/main';
import {
    USERS_GET_ALL,
    USER_CHANGE_PASSWORD,
    USER_CHANGE_STATUS,
    USER_DELETE
} from '@/store/Actions/users';
import {
    GET_SCHOOLS
} from '@/store/Actions/user';

export default {
    name: "UserManagement",
    components: {
        ChangePasswordModal
    },
    data() {
        return {
            filter_form: {
                query: ""
            },
            filter_dropdown: false,
            filter_data: "all",
            school_filter_dropdown: false,
            school_filter_data: "all",
            schools_list: [],
            filtered_schools: [],
            school_search_query: "",
            loadingSchools: false,
            school_search_timeout: null,
            selectedUsers: [],
            selectAll: false,
            showPasswordModal: false,
            selectedUser: null,
            loading: false,
            current_page: 1,
            searchTimeout: null,

            user_type_filter: [
                { name: "All Users", value: "all" },
                { name: "Students", value: "students" },
                { name: "Instructors", value: "instructors" },
                // { name: "Consultants", value: "consultants" },
                // { name: "Customers", value: "customers" },
                // { name: "Admins", value: "admins" }
            ]
        };
    },
    computed: {
        ...mapGetters(['getAllUsers', 'getUsersPagination', 'isUsersLoading']),

        users_data() {
            return this.getUsersPagination;
        },

        filtered_users() {
            // Return users directly from API - no frontend filtering
            return this.getAllUsers || [];
        }
    },
    mounted() {
        this.loadUsers();
        this.loadSchools();
    },
    beforeDestroy() {
        // Clean up search timeouts if component is destroyed
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        if (this.school_search_timeout) {
            clearTimeout(this.school_search_timeout);
        }
    },
    methods: {
        ...mapActions([USERS_GET_ALL, USER_CHANGE_PASSWORD, USER_CHANGE_STATUS, USER_DELETE, GET_SCHOOLS]),

        async loadUsers() {
            // Use the unified filtering method
            this.loadUsersWithFilters();
        },

        async searchUser() {
            // Clear previous timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Add small delay to avoid too many API calls while typing
            this.searchTimeout = setTimeout(() => {
                this.current_page = 1; // Reset to first page when searching
                this.loadUsersWithFilters();
            }, 500); // Wait 500ms after user stops typing
        },

        async filterByUserType(item) {
            this.filter_data = item.value;
            this.filter_dropdown = false;
            this.current_page = 1; // Reset to first page when filtering
            this.loadUsersWithFilters();
        },

        async filterBySchool(item) {
            this.school_filter_data = item.value;
            this.school_filter_dropdown = false;
            this.current_page = 1; // Reset to first page when filtering
            this.loadUsersWithFilters();
        },

        async loadSchools(searchQuery = '') {
            this.loadingSchools = true;
            try {
                const payload = {
                    url_type: 'init'
                };

                // Add search query if provided
                if (searchQuery && searchQuery.trim() !== '') {
                    payload.search = searchQuery.trim();
                }

                const response = await this[GET_SCHOOLS](payload);

                if (response.data && response.data.data) {
                    this.schools_list = response.data.data || [];
                    this.filtered_schools = this.schools_list;
                } else {
                    this.schools_list = [];
                    this.filtered_schools = [];
                }
            } catch (error) {
                console.error('Error loading schools:', error);
                this.schools_list = [];
                this.filtered_schools = [];
            } finally {
                this.loadingSchools = false;
            }
        },

        searchSchools() {
            // Clear previous timeout
            if (this.school_search_timeout) {
                clearTimeout(this.school_search_timeout);
            }

            // Add small delay to avoid too many API calls while typing
            this.school_search_timeout = setTimeout(() => {
                if (this.school_search_query.trim() === '') {
                    // If search is empty, load all schools
                    this.loadSchools();
                } else {
                    // Load schools with search query
                    this.loadSchools(this.school_search_query);
                }
            }, 300); // Wait 300ms after user stops typing
        },

        getSchoolDisplayName(school) {
            // Handle both possible property names from API
            return school.school_name || school.name || 'Unknown School';
        },

        getSelectedSchoolName() {
            if (this.school_filter_data === 'all') {
                return 'All Schools';
            }
            const selectedSchool = this.schools_list.find(school => school.id === this.school_filter_data);
            return selectedSchool ? this.getSchoolDisplayName(selectedSchool) : 'Select School';
        },

        async loadUsersWithFilters() {
            this.loading = true;
            try {
                const payload = {
                    url_type: 'init',
                    page: this.current_page,
                    per_page: 10
                };

                // Add search query if present
                if (this.filter_form.query && this.filter_form.query.trim() !== '') {
                    payload.query = this.filter_form.query.trim();
                }

                // Add user type filter if not 'all'
                if (this.filter_data !== 'all') {
                    const typeMapping = {
                        'students': 4,
                        'instructors': 3,
                        'customers': 2,
                        'consultants': 1,
                        'admins': 5
                    };
                    payload.account_type = typeMapping[this.filter_data];
                }

                // Add school filter if not 'all'
                if (this.school_filter_data !== 'all') {
                    payload.school_id = this.school_filter_data;
                }

                // You can add more filters here, like:
                // if (this.status_filter !== 'all') {
                //     payload.status = this.status_filter;
                // }
                // if (this.date_filter) {
                //     payload.date_from = this.date_filter.from;
                //     payload.date_to = this.date_filter.to;
                // }

                const response = await this[USERS_GET_ALL](payload);

                if (response.data) {
                    // Handle different possible response structures
                    let users = [];
                    let paginationData = {};

                    // Check if response has success wrapper
                    if (response.data.success && response.data.data) {
                        users = response.data.data.data || response.data.data || [];
                        paginationData = response.data.data;
                    } else {
                        // Direct API response structure (your JSON example)
                        users = response.data.data || [];
                        paginationData = response.data;
                    }

                    this.$store.commit('SET_USERS', users);
                    this.$store.commit('SET_USERS_PAGINATION', {
                        total: paginationData.total || 0,
                        per_page: paginationData.per_page || 20,
                        current_page: paginationData.current_page || 1,
                        last_page: paginationData.last_page || 1,
                        from: paginationData.from || 0,
                        to: paginationData.to || 0
                    });
                }
            } catch (error) {
                console.error('Error loading users with filters:', error);
                this.$store.commit('SET_ERROR', 'Failed to load users');
            } finally {
                this.loading = false;
            }
        },



        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedUsers = this.filtered_users.map(user => user.id);
            } else {
                this.selectedUsers = [];
            }
        },

        changePassword(user) {
            this.selectedUser = user;
            this.showPasswordModal = true;
        },

        closePasswordModal() {
            this.showPasswordModal = false;
            this.selectedUser = null;
        },

        handlePasswordChanged(data) {
            // Handle successful password change
            console.log(`Password changed for user: ${data.user.email}`);
            alert(`Password successfully changed for ${data.user.first_name} ${data.user.last_name}`);
        },

        handlePasswordError(error) {
            // Handle password change error
            console.error("Error changing password:", error);
            alert("Failed to change password. Please try again.");
        },



        viewUser(user) {
            console.log("View user:", user);
            // Implement view user details functionality
        },

        async toggleUserStatus(user) {
            try {
                const payload = {
                    user_id: user.id,
                    activated: !user.activated
                };

                const response = await this[USER_CHANGE_STATUS](payload);

                if (response.data && response.data.message == "success") {
                    // Update user in store
                    const updatedUser = { ...user, activated: payload.activated };
                    this.$store.commit('UPDATE_USER', updatedUser);

                    // Show success message
                    alert(`User ${payload.activated ? 'activated' : 'deactivated'} successfully`);
                } else {
                    alert('Failed to update user status');
                }
            } catch (error) {
                console.error('Error updating user status:', error);
                alert('Failed to update user status');
            }
        },

        async banUser(user) {
            try {
                const payload = {
                    user_id: user.id,
                    banned: true
                };

                const response = await this[USER_CHANGE_STATUS](payload);

                if (response.data && response.data.message == "success") {
                    // Update user in store
                    const updatedUser = { ...user, banned: true };
                    this.$store.commit('UPDATE_USER', updatedUser);

                    // Show success message
                    alert(`User banned successfully`);
                } else {
                    alert('Failed to ban user');
                }
            } catch (error) {
                console.error('Error banning user:', error);
                alert('Failed to ban user');
            }
        },

        async unbanUser(user) {
            try {
                const payload = {
                    user_id: user.id,
                    banned: false
                };

                const response = await this[USER_CHANGE_STATUS](payload);

                if (response.data && response.data.message == "success") {
                    // Update user in store
                    const updatedUser = { ...user, banned: false };
                    this.$store.commit('UPDATE_USER', updatedUser);

                    // Show success message
                    alert(`User unbanned successfully`);
                } else {
                    alert('Failed to unban user');
                }
            } catch (error) {
                console.error('Error unbanning user:', error);
                alert('Failed to unban user');
            }
        },

        confirmDeleteUser(user) {
            eventBus.$emit("openDialogMessage", {
                title: "Delete User",
                message: `Are you sure you want to delete <strong>${user.first_name} ${user.last_name}</strong>? This action cannot be undone.`,
                action_label: "Delete User",
                action_close_label: "Cancel",
                callback: () => {
                    this.deleteUser(user);
                }
            });
        },

        async deleteUser(user) {
            try {
                const payload = {
                    user_id: user.id
                };

                const response = await this[USER_DELETE](payload);

                if (response.data && response.data.message == "success") {
                    // Remove user from store
                    this.$store.commit('REMOVE_USER', user.id);

                    // Show success message
                    alert(`User ${user.first_name} ${user.last_name} deleted successfully`);

                    // Refresh pagination data
                    this.loadUsers();
                } else {
                    alert('Failed to delete user');
                }
            } catch (error) {
                console.error('Error deleting user:', error);
                alert('Failed to delete user');
            }
        },

        async changePage(page) {
            this.current_page = page;
            this.loadUsersWithFilters();
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        },

        getUserType(accountType) {
            // Map account_type to CSS class
            switch (accountType) {
                case 4: return 'student';
                case 3: return 'instructor';
                case 2: return 'customer';
                case 1: return 'consultant';
                case 5: return 'admin';
                default: return 'unknown';
            }
        },

        getUserTypeLabel(accountType) {
            // Map account_type to display label
            switch (accountType) {
                case 4: return 'Student';
                case 3: return 'Instructor';
                case 2: return 'Customer';
                case 1: return 'Consultant';
                case 5: return 'Admin';
                default: return 'Unknown';
            }
        },

        getUserStatus(user) {
            // Determine status based on user properties
            if (user.banned) return 'banned';
            if (!user.verified) return 'unverified';
            if (!user.activated) return 'inactive';
            if (user.on_trial) return 'trial';
            return 'active';
        },

        getUserStatusLabel(user) {
            // Get user-friendly status label
            if (user.banned) return 'Banned';
            if (!user.verified) return 'Unverified';
            if (!user.activated) return 'Inactive';
            if (user.on_trial) return 'Trial';
            return 'Active';
        }
    }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f8f9fa;
}

.page-header {
    background: white;
    border-bottom: 1px solid #e9ecef;
    padding: 0;
}

.options {
    display: flex;
    align-items: center;
    gap: 10px;

    .search-user {
        min-width: 250px;
    }

    .v-line-divider {
        width: 1px;
        background: #e9ecef;
    }

    .btn-dropdown {
        background: white;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 8px 12px;
        color: #495057;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            border-color: #1BA5A4;
            color: #1BA5A4;
        }

        .icon {
            width: 12px;
            height: 12px;
        }
    }

    .btn-add-user {
        display: flex;
        align-items: center;
        gap: 8px;

        .icon {
            width: 16px;
            height: 16px;
        }
    }
}

.page-body {
    flex: 1;
    padding: 20px;
    overflow: auto;
}

.users-list-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.users-table-wrapper {
    overflow-x: auto;
}

.users-table {
    width: 100%;
    border-collapse: collapse;

    .table-header {
        background: #f8f9fa;
        padding: 16px 12px;
        text-align: left;
        font-weight: 600;
        color: #495057;
        border-bottom: 1px solid #dee2e6;
        font-size: 14px;
    }

    .table-row {
        transition: background-color 0.2s;

        &:hover {
            background: #f8f9fa;
        }

        &.selected {
            background: #e3f2fd;
        }
    }

    .table-cell {
        padding: 16px 12px;
        border-bottom: 1px solid #f1f3f4;
        vertical-align: middle;
    }

    .user-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
        }

        .user-details {
            .user-name {
                font-weight: 500;
                color: #2c3e50;
                font-size: 14px;
            }

            .user-id {
                color: #6c757d;
                font-size: 12px;
                margin-top: 2px;
            }
        }
    }

    .user-type {
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;

        &.student {
            background: #e3f2fd;
            color: #1976d2;
        }

        &.instructor {
            background: #f3e5f5;
            color: #7b1fa2;
        }

        &.customer {
            background: #e8f5e8;
            color: #2e7d32;
        }

        &.consultant {
            background: #fff3e0;
            color: #ef6c00;
        }

        &.admin {
            background: #fce4ec;
            color: #ad1457;
        }

        &.unknown {
            background: #f5f5f5;
            color: #757575;
        }
    }

    .status-badge {
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        text-transform: capitalize;

        &.active {
            background: #e8f5e8;
            color: #2e7d32;
        }

        &.inactive {
            background: #ffebee;
            color: #c62828;
        }

        &.trial {
            background: #fff3e0;
            color: #ef6c00;
        }

        &.banned {
            background: #fce4ec;
            color: #ad1457;
        }

        &.unverified {
            background: #f3e5f5;
            color: #8e24aa;
        }
    }

    .checkbox {
        accent-color: #1BA5A4;
    }
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #6c757d;

    .empty-icon {
        width: 64px;
        height: 64px;
        margin-bottom: 16px;
        opacity: 0.5;
    }

    h3 {
        margin: 0 0 8px;
        color: #495057;
    }

    p {
        margin: 0;
    }
}

.pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-top: 1px solid #dee2e6;

    .pagination-info {
        color: #6c757d;
        font-size: 14px;
    }

    .pagination-controls {
        display: flex;
        align-items: center;
        gap: 12px;

        .pagination-btn {
            background: white;
            border: 1px solid #dee2e6;
            border-radius: 6px;
            padding: 6px 12px;
            color: #495057;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;

            &:hover:not(:disabled) {
                border-color: #1BA5A4;
                color: #1BA5A4;
            }

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }

        .pagination-page {
            color: #495057;
            font-size: 14px;
            font-weight: 500;
        }
    }
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 500px;
    width: 90%;

    h2 {
        margin: 0 0 16px;
        color: #2c3e50;
    }

    p {
        margin: 0 0 20px;
        color: #6c757d;
    }

    .btn-cancel {
        background: #6c757d;
        color: white;
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
        cursor: pointer;

        &:hover {
            background: #5a6268;
        }
    }
}

.text-danger {
    color: #dc3545 !important;
}

.schools-dropdown {
    min-width: 280px !important;
    max-height: 350px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .dropdown-search {
        padding: 8px 12px;
        border-bottom: 1px solid #e9ecef;
        background: #f8f9fa;

        .search-input {
            width: 100%;
            padding: 8px 12px;
            border: 1px solid #dee2e6;
            border-radius: 4px;
            font-size: 14px;
            outline: none;
            transition: border-color 0.2s;

            &:focus {
                border-color: #1BA5A4;
                box-shadow: 0 0 0 2px rgba(27, 165, 164, 0.1);
            }

            &::placeholder {
                color: #6c757d;
            }
        }
    }

    .dropdown-items {
        max-height: 280px;
        overflow-y: auto;
        flex: 1;

        .dropdown-item {
            display: block;
            padding: 8px 12px;
            color: #495057;
            text-decoration: none;
            font-size: 14px;
            transition: background-color 0.2s;

            &:hover {
                background-color: #f8f9fa;
                color: #1BA5A4;
            }
        }

        .loading-item,
        .no-results {
            padding: 12px;
            text-align: center;
            color: #6c757d;
            font-size: 14px;
            font-style: italic;
        }

        .no-results {
            background-color: #f8f9fa;
        }
    }
}
</style>